import request from '@/util/http.js'
//面试列表
export const auditionList = (query) => {
  return request({
    url: '/audition/auditionList',
    method: 'get',
    params: query
  })
}
// 转其他
export const torencai = (data) => {
  return request({
    url: '/audition/torencai',
    method: 'post',
    data
  })
}
// 编辑面试
export const editAudition = (data) => {
  return request({
    url: '/audition/editAudition',
    method: 'post',
    data
  })
}
// 转入正式员工
export const transferEmployee = (data) => {
  return request({
    url: '/audition/transferEmployee',
    method: 'post',
    data
  })
}
// 根据id查询面试信息
export const getAuditionInfoById = (query) => {
  return request({
    url: '/audition/getAuditionInfoById',
    method: 'get',
    params: query
  })
}
// 删除员工
export const delAudition = (data) => {
  return request({
    url: '/audition/delAudition',
    method: 'delete',
    data: data
  })
}

// // 查询所有
// export const search = (query) => {
//   return request({
//     url: '/audition/search',
//     method: 'get',
//     params: query
//   })
// }
